/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationWarrantiesGroupProtectionQuery from '../graphql/queries/GetSimulationWarrantiesGroupProtectionQuery.js';

const useGetSimulationWarrantiesGroupProtectionQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationWarrantiesGroupProtectionQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationWarrantiesGroupProtection: R.omit(['__typename'], data?.getSimulationWarrantiesGroupProtection_simulation_warranties_group_protection || {})
  };
};

export default useGetSimulationWarrantiesGroupProtectionQuery;
